import React from 'react'
import { Distance, Elevation } from 'common/units'
import { CardBody, Metrics, Metric, HoverPreviewImage } from 'common/hovercards/CardBody'
import { MountOnHoverCard } from 'common/hovercards/MountOnHoverCard'
import { j } from 'lib/textUtils'
import { Msg, commonMetrics, commonTRouteMessages } from 'lib/localization'
import PropTypes from 'prop-types'

export class SegmentCard extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    distance: PropTypes.number.isRequired,
    elevationGain: PropTypes.number.isRequired
  }

  render () {
    const { children, title, type, id, distance, elevationGain, locality, administrativeArea } = this.props

    const image = <HoverPreviewImage type={type} id={id} />
    const content = <Metrics>
      <Metric label={<Msg m={commonMetrics.distance} />} value={<Distance short value={distance} />} />
      <Metric label={<Msg m={commonMetrics.elevationGain} />} value={<Elevation short value={elevationGain} />} />
      <Metric label={<Msg m={commonTRouteMessages.startLocation} />} value={j([locality, administrativeArea])} />
    </Metrics>

    return (
      <MountOnHoverCard wrappedChildren={children}>
        <CardBody
          header={title}
          image={image}
          content={content} />
      </MountOnHoverCard>
    )
  }
}
